module.exports = __webpack_public_path__ + "static/media/info.a01ec69f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/info.svg
// module id = 176
// module chunks = 0